import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';

function AuthProvider(props) {
  //console.log('AuthProvider Load');

  const [user, setUser] = useState(); //괄호안에 상태 초기값
  const authenticated = user != null;
  const [loading, setLoading] = useState(true);
  //const encrypt = require('../../pbkdf2/service/modules/crpyto');
  const encrypt = require('../pbkdf2/service/modules/crpyto');

  useEffect(() => {
    //컴포넌트가 렌더링 될 때마다 실행되는 hook
    //console.log('AuthProvider > useEffect()');
    (async function () {
      const result = await getUser(); // src/api/auth.js내 함수

      if (result.isOk) {
        console.log('AuthProvider > isOk');
        setUser(result.data);
      } else {
        console.log('AuthProvider > isNo');
        alert('로그인 오류');
      }
      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (id, password) => {
    //console.log('AuthProvider > signIn');

    const result = await sendSignInRequest(id); // src/api/auth.js내 함수
    //console.log('result::',result);
    if (result.isOk) {
      //id존재 확인

      const userInfo = result.data.Password.split(':');

      // console.log(result.data.Password);
      // console.log(userInfo[2]);
      // console.log(userInfo[3]);

      encrypt.encryptWithSalt(password, userInfo[2]).then(function (value) {
        if (value === userInfo[3]) {
          sessionStorage.setItem('userCode', result.data.Code);
          sessionStorage.setItem('userEmail', result.data.Email);
          sessionStorage.setItem('userId', result.data.Id);
          sessionStorage.setItem('userLineNumber', result.data.LineNumber);
          sessionStorage.setItem('userName', result.data.Name);

          setUser(result.data);
          return true;
        } else {
          setUser();
          return false;
        }
      });
    } else {
      return false;
    }
  }, []);

  const signOut = useCallback(() => {
    setUser();
    sessionStorage.setItem('userId', null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, signIn, signOut, loading }}
      {...props}
    />
  );
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
